import React from "react";

function DeleteIcon({ w = 20, h = 22 }) {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 3.5H16V18.5C16 19.8807 14.8807 21 13.5 21H6C4.61929 21 3.5 19.8807 3.5 18.5V3.5ZM9.75 1C11.068 1 12.1477 2.01985 12.2431 3.31342L12.25 3.5H7.25C7.25 2.11929 8.36929 1 9.75 1Z"
        stroke="#A5A5A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 3.5H18.5"
        stroke="#A5A5A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25 7.25V17.25"
        stroke="#A5A5A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 7.25V17.25"
        stroke="#A5A5A5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DeleteIcon;
